import { render, staticRenderFns } from "./TeamsBoardComponent.vue?vue&type=template&id=35842c9c&"
import script from "./TeamsBoardComponent.vue?vue&type=script&lang=js&"
export * from "./TeamsBoardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports